import * as JSONPath from 'jsonpath';
export function deep_sync_adv(target, obj, options = {}) {
    deepSyncInternal(target, obj, {
        refPaths: normalizeFilter(options.refs, obj),
        excludePaths: normalizeFilter(options.exclude, obj),
        currentPath: ['$'],
        delete_missing: true,
    });
    return target;
}
export function deep_merge_adv(target, obj, options = {}) {
    deepSyncInternal(target, obj, {
        refPaths: normalizeFilter(options.refs, obj),
        excludePaths: normalizeFilter(options.exclude, obj),
        currentPath: ['$'],
        delete_missing: false,
    });
    return target;
}
export function deep_duplicate_adv(obj, options = {}) {
    const target = Array.isArray(obj) ? [] : {};
    return deep_merge_adv(target, obj, options);
}
export function deepSyncInternal(target, source, options) {
    const initMissingValue = options.initializeMissingValue || ((v, recurse) => {
        const dest = Array.isArray(v) ? [] : {};
        return recurse(dest);
    });
    for (let [k, v] of Object.entries(source)) {
        const currentPath = [...options.currentPath, k];
        const currentPathSpec = JSONPath.stringify(currentPath);
        if (options.excludePaths(currentPathSpec, v))
            continue;
        const recurse = (dest) => {
            deepSyncInternal(dest, v, {
                ...options,
                currentPath,
            });
            return dest;
        };
        if (options.refPaths(currentPathSpec, v) || typeof v != 'object' || v == null) {
            target[k] = v;
        }
        else if (Object.getPrototypeOf(v) != Object.prototype && !Array.isArray(v)) {
            target[k] = v;
        }
        else if (typeof v != typeof target[k] || target[k] === v) {
            target[k] = initMissingValue(v, recurse);
        }
        else if (Array.isArray(v) && Array.isArray(target[k])) {
            recurse(target[k]);
        }
        else if (target[k] == null || (Object.getPrototypeOf(target[k]) != Object.prototype)) {
            target[k] = initMissingValue(v, recurse);
        }
        else {
            recurse(target[k]);
        }
    }
    if (options.delete_missing !== false) {
        const keys = Object.keys(target);
        for (let k of keys) {
            if (!(k in source)) {
                if (Array.isArray(target))
                    target.splice(k, 1);
                else
                    delete target[k];
            }
        }
    }
}
export function normalizeFilter(spec, obj) {
    if (typeof spec == 'function')
        return spec;
    if (typeof spec == 'string')
        spec = [spec];
    const pathset = buildPathSets(obj, spec);
    return (path, obj) => pathset.has(path);
}
function buildPathSets(obj, paths) {
    const pathSet = new Set();
    for (let path of paths || []) {
        const js_paths = JSONPath.paths(obj, path);
        for (let jsp of js_paths) {
            pathSet.add(JSONPath.stringify(jsp));
        }
    }
    return pathSet;
}
//# sourceMappingURL=deep_sync_adv.js.map